import React, { Component, Fragment } from 'react';
import Header from '../components/Header';
import SideNav from '../components/SideNav'
import Footer from '../components/Footer';
import $ from 'jquery';

export default class Main extends Component {
  componentDidMount = () => {
    var drawer = '[data-swipe-drawer]';
    var panel = '[data-swipe-panel]';
    var overlay = '[data-swipe-overlay]';
    var noScrollClass = 'no-scroll';
    var flickThreshold = 20;

    // Initialise variables
    var openClass = $(drawer).data('swipe-open-class');
    var width = 0;
    var posStart = 0;
    var translateStart = 0;
    var diff = 0;
    var xPos = 0;
    var longTouch = true;

    $(drawer).on('touchstart', function(ts) {
       xPos = 0;
       width = $(this).children(panel).width();
      posStart = ts.originalEvent.touches[0].pageX;
      
      // get the current translate value of the panel based on it's open-state
      translateStart = -width;
      if ($(this).hasClass(openClass)) {
        translateStart = 0;
      };
      
      // set timer for "flicking"
      longTouch = false;
      setTimeout(function() {
        longTouch = true;
      }, 250);

      // Make drawer visible while interacting
      $(this).css('visibility', 'visible');
    });

    $(drawer).on('touchmove', function(tm) {
      xPos = tm.originalEvent.touches[0].pageX - posStart;
      diff = translateStart + xPos;
      
      // Set styles depending on how far the touchmove moves
      if (diff >= -width && diff <= 0) {
        $(this).children(panel).css({
          'transform': 'translate3d(' + diff + 'px,0,0)',
          'transition-duration': '0s'
        });
        $(this).children(overlay).css({
          'opacity': 1 - (-1 / width * diff),
          'transition-duration': '0s'
        });
      }
    });

    $(drawer).on('touchend', function() {
      // Determine flick
      var flickClose = false;
      var flickOpen = false;
      if (!longTouch) {
        if (xPos > flickThreshold) {
          flickOpen = true;
        } else if (xPos < -flickThreshold) {
          flickClose = true;
        }
      }
      
      // Determine if drawer should be open
      if (flickOpen || xPos >= width/2) {
        $(this).addClass(openClass);
        $('body').addClass(noScrollClass);
       } else if (flickClose || xPos < -width/2) {
        $(this).removeClass(openClass);
        $('body').removeClass(noScrollClass);
      }
      
      // Remove inline css from js animation
      $(this).removeAttr('style');
      $(this).children(panel).removeAttr('style');
      $(this).children(overlay).removeAttr('style');
    });

    $('[data-swipe-overlay], [data-swipe-close]').on('click', function(e) {
      e.preventDefault();
      $(drawer).removeClass(openClass);
      $('body').removeClass(noScrollClass);
    });

    $('[data-swipe-open]').on('click', function(e) {
      e.preventDefault();
      $(drawer).addClass(openClass);
      $('body').addClass(noScrollClass);
    });

    $(window).bind('scroll', function() {
      if ($(window).scrollTop() > 70) {
        $('.nav-atas').addClass('fixed');
      } else {
        $('.nav-atas').removeClass('fixed');
      }
    });
  }
  render() {
    const { children } = this.props;
    return (
      <Fragment>
        <Header/>
        <SideNav/>
        {children}
        <Footer/>
      </Fragment>
    )
  }
}
